import React, { useContext } from 'react';
import { DateTimeUtils, Table, } from 'dyl-components';

import { MathUtils, StringUtils } from 'utils';
import PaymentInfo from 'shared/PaymentInfo';
import QuoteID from 'shared/QuoteID';
import { QuoteBuilderContext } from 'shared/context/QuoteBuilderProvider';

export const TransactionHistoryRow = ({ transaction }) => {
    const { onViewInvoice } = useContext(QuoteBuilderContext);
    const balance = transaction?.balance ? MathUtils.roundDecimals(transaction?.balance ).toString() : "0.00"
    return (
        <Table.Row>
            <Table.Cell >
                <div><b>{DateTimeUtils.formatEpoch(transaction.date, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(transaction.date, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell >
                {StringUtils.capitalize(transaction.invoice_status)}
            </Table.Cell>
            <Table.Cell >
                {<PaymentInfo info={{
                    payment_type: transaction.payment_method.payment_type,
                    payment_account: transaction.payment_method.payment_account,
                    payment_network: transaction.payment_method.payment_method
                }} />}
            </Table.Cell>
            <Table.Cell >
               {transaction?.transaction_status && <div className={`TransactionHistoryTable__TransactionStaus${transaction?.transaction_status === "payment_successful" ? "--success" : "--failed"}`}>
                    <b>Payment {transaction?.transaction_status === "payment_successful" ? "Successful " : "Failed"}</b>
                </div>}
            </Table.Cell>
            <Table.Cell >
                {(transaction?.transaction_type || "").split("_").map(word => StringUtils.capitalize(word)).join(" ")}
            </Table.Cell>
            <Table.Cell >
                $
                {StringUtils.formatDecimal(
                    `${MathUtils.roundDecimals(transaction?.amount)}`
                    , true)}
            </Table.Cell>
            <Table.Cell >
                <div className={`TransactionHistoryTable__TransactionStaus${ balance === "0.00" ? "": balance > 0  ? "--success" : "--failed"}`}>

                    ${StringUtils.formatDecimal(balance
                        , true)}
                </div>
            </Table.Cell>
            <Table.Cell >
                <div>
                    <QuoteID
                        onEditQuote={() => {
                            onViewInvoice(transaction.invoice, true);
                        }}
                        onViewProposal={() => {
                            onViewInvoice(transaction.invoice, true);
                        }}
                        id={transaction.invoice}
                        hasPdf
                        hideCopy
                    />
                </div>
            </Table.Cell>
        </Table.Row>
    );
}
